module.exports = __webpack_public_path__ + "img/access.9f8de66d.png";